var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { wrapAuthorizeUrl } from '@tujia/fe-lib-common/lib/tj-channel/elong';
import { getOriginByUrl, getQueryByUrl, getQueryStrByObj, urlAppendQuery } from '@tujia/fe-lib-common/lib/utils/url-helper';
import { getHostByEnv } from '@tujia/fe-lib-common/lib/tj-utils/env';
import { mpUtils } from './sdk';
import { getPlatform } from '@tujia/fe-lib-common/lib/tj-utils/platform';
import { channelTypes, getChannelInfo } from '@tujia/fe-lib-common/lib/tj-channel';
import { getTujiaCode } from '@tujia/fe-lib-common/lib/tj-storage';
/**
 * 设置四方小程序分享 - 自动定位渠道设置 支持 TCQME
 * @param { MpShareConfig } config
 */
export function setBnbMpShare(config) {
    var channelInfo = getChannelInfo();
    var bnbShareConfig = getBnbMpShareConfig(config);
    // 老 config 和 bnb 属性不冲突，可直接合并使用
    var shareConfig = null;
    if (channelInfo.channelId === channelTypes.CTRIP) {
        var ctripOldShareConfig = getCtripOldMpShareConfig(config);
        shareConfig = __assign(__assign({}, bnbShareConfig), ctripOldShareConfig);
    }
    else if (channelInfo.channelId === channelTypes.QUNAR) {
        shareConfig = bnbShareConfig;
    }
    else if (channelInfo.channelId === channelTypes.ELONG) {
        shareConfig = getElongMpShareConfig(config);
    }
    else {
        var tujiaOldShareConfig = getTujiaOldMpShareConfig(config);
        shareConfig = __assign(__assign({}, bnbShareConfig), tujiaOldShareConfig);
    }
    // 后续转新版本 - 最好两个版本 post 都支持
    mpUtils.postMessage({ data: shareConfig });
}
/**
 * 打开四方分享页面
 * @param { MpSharePageConfig } config
 */
export function openBnbMpSharePage(config) {
    var channelInfo = getChannelInfo();
    var pageData = { path: '', query: {} };
    if (channelInfo.channelId === channelTypes.CTRIP) {
        pageData = getCtripMpSharePageData(config);
    }
    else if (channelInfo.channelId === channelTypes.QUNAR) {
        pageData = getQunarMpSharePageData(config);
    }
    else if (channelInfo.channelId === channelTypes.ELONG) {
        throw new Error('elong un support openBnbMpSharePage');
    }
    else {
        pageData = getTujiaMpSharePageData(config);
    }
    mpUtils.navigateTo({
        url: urlAppendQuery(pageData.path, pageData.query)
    });
}
/**
 * 分享路径公共处理
 * 1. 增加分享 traceId
 * 2. 删除敏感信息 tjuserid tjusertoken openid
 * 3. 无 path，强制 m 站
 * @param path 路径
 * @param shareParams 分享参数
 */
function shareUrlHelper(path, shareParams) {
    shareParams = shareParams || {};
    var channelInfo = getChannelInfo();
    var platformInfo = getPlatform();
    var commonParams = {
        tjchannelid: channelInfo.channelId,
        code: channelInfo.channelId + "_" + platformInfo.platformValue + "_share"
    };
    if (window._fas) {
        var traceId = window._fas.getTraceId();
        shareParams._fasShareTraceId = "share_" + traceId;
    }
    if (path) {
        var pathObj = getQueryByUrl(path) || {};
        delete pathObj.tjuserid;
        delete pathObj.tjusertoken;
        delete pathObj.tjopenid;
        delete pathObj.openid;
        delete pathObj.openId;
        //判断cookie中是否有code
        var code_cookie = getTujiaCode();
        var oldCode = pathObj.code || code_cookie || '';
        if (oldCode) {
            if (!oldCode.endsWith('_shareb')) {
                oldCode += '_shareb';
            }
            commonParams.code = oldCode;
            delete pathObj.code;
        }
        shareParams = __assign(__assign(__assign({}, commonParams), pathObj), shareParams);
        path = getOriginByUrl(path);
    }
    else {
        // 如果没传url， 默认分享首页, 仅限 H5
        path = getHostByEnv('m');
    }
    // 整合参数
    var shareParamsStr = getQueryStrByObj(shareParams);
    return path + "?" + shareParamsStr;
}
function getTujiaOldMpShareConfig(config) {
    var url = shareUrlHelper(config.url);
    return {
        msgKey: 'onShare',
        msgData: {
            title: config.title || '途家民宿公寓预订',
            imageUrl: config.imageUrl,
            path: "/pages/webview/index?h5url=" + encodeURIComponent(url)
        }
    };
}
function getCtripOldMpShareConfig(config) {
    var url = shareUrlHelper(config.url);
    return {
        type: 'onShare',
        shareData: __assign({ bu: 'tujia_hotel', title: config.title || '携程民宿公寓预订', imageUrl: config.imageUrl, path: "/cwx/component/cwebview/cwebview?data=" + JSON.stringify({
                url: encodeURIComponent(url)
            }) }, config.shareData)
    };
}
function getElongMpShareConfig(config) {
    var url = config.url;
    var mHostUrl = getHostByEnv('m');
    if (url && url.indexOf(mHostUrl) === -1) {
        // 先做一轮参数拼接
        url = shareUrlHelper(url, config.shareData);
        // 非M站域名，目前强制中转 拼接
        url = mHostUrl + "/tbnb/common/goToPage?targetUrl=" + encodeURIComponent(url);
    }
    // auth 包装一层 URL
    var shareUrl = wrapAuthorizeUrl(shareUrlHelper(url, config.shareData));
    return {
        shareInfo: {
            // 是否回传h5触发了分享，获取回传数据参考第4条功能，分享数据
            backShare: false,
            // 是否是分享小程序原生页面地址
            isMiniApp: false,
            // 分享链接是否经过首页中转
            showBack: true,
            // 当前页面路径，不需要参数
            currentPath: location.host + location.pathname,
            title: config.title || '同程旅行民宿公寓预订',
            // 默认当前页面路径
            path: shareUrl,
            // 支持PNG及JPG，不传入 imageUrl 则使用默认截图。显示图片长宽比是 5:4
            imageUrl: config.imageUrl
        }
    };
}
function getBnbMpShareConfig(config) {
    var url = shareUrlHelper(config.url);
    var channelInfo = getChannelInfo();
    return {
        type: 'onShare',
        data: {
            title: config.title || channelInfo.channelText + "\u6C11\u5BBF\u516C\u5BD3\u9884\u8BA2",
            imageUrl: config.imageUrl,
            path: url
        }
    };
}
/**
 * 跳转途家分享页面，路径支持 原生和H5
 */
function getTujiaMpSharePageData(config) {
    var url = config.url;
    if (url.indexOf('http') === 0) {
        url = shareUrlHelper(url);
    }
    return {
        path: '/pages/webview/share/share',
        query: __assign({ shareContTxt: config.title, sharePath: url.indexOf('http') === 0 ? url : '', miniPath: url.indexOf('http') !== 0 ? url : '', shareImageUrl: config.cardImageUrl, canvasimgUrl: config.circleImageUrl, bgImgUrl: config.bgImageUrl }, config.shareData)
    };
}
/**
 * 跳转去哪儿分享页面，路径支持 原生和H5
 */
function getQunarMpSharePageData(config) {
    var path = config.url;
    if (config.url.indexOf('http') === 0) {
        var url = shareUrlHelper(config.url);
        path = "/pages/tbnb/pages/common/webview/index?h5url=" + encodeURIComponent(url);
    }
    return {
        path: "/pages/bnb/share/index?title=" + config.title + "&wechatImg=" + config.cardImageUrl + "&timeLineImg=" + config.circleImageUrl,
        query: __assign({ sharePath: '/home/pages/index?navigateTo=' + encodeURIComponent(path) }, config.shareData)
    };
}
/**
 * 跳转携程分享页面，路径支持 原生和H5
 */
function getCtripMpSharePageData(config) {
    var url = config.url;
    if (url.indexOf('http') === 0) {
        url = shareUrlHelper(config.url);
        url = "/pages/tbnb/pages/common/webview/index?h5url=" + encodeURIComponent(url);
    }
    return {
        path: "/pages/hotel/share/index?title=" + config.title,
        query: __assign({ path: window.btoa(url), imageUrl: config.cardImageUrl, circleUrl: config.circleImageUrl, bgImage: config.bgImageUrl }, config.shareData)
    };
}
